import React from 'react'
import Header from '../../User/layouts/Header';
import '../../User/styles/pages/profile.scss';
import { Typography, Container, ListItem, List } from '@mui/material';
import Grid from '@mui/material/Grid2';
import overview from '../../User/assets/icons/overview.svg';
import user from '../../User/assets/icons/account-details.svg';
import about from '../../User/assets/icons/about.svg';
import address from '../../User/assets/icons/address.svg';
import faq from '../../User/assets/icons/faq.svg';
import terms_conditions from '../../User/assets/icons/terms&conditions.svg';
import privacy from '../../User/assets/icons/privacy.svg'
import { Outlet, Link, useLocation } from 'react-router-dom';
import WhatsApp from "../../User/components/WhatsApp";
import { useGlobalContext } from '../../context/Context';
import consultation_icon from '../../User/assets/icons/consultation.svg';
import orders_icon from '../../User/assets/icons/myorder.svg';

const Profile = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  return (
    <React.Fragment>
      <Header />
      {/* <section className='profile'>
        <Container maxWidth="xl">
          <div className='profile-title'>
            <Typography variant='h5'>Profile</Typography>
            <Typography>{userName?.name}</Typography>
          </div>
        </Container>
      </section> */}
      <section className='profile-sidebar'>
        <Container maxWidth="xl">
          <Grid container spacing={{ xs: 2, sm: 3, md: 4, lg: 4 }}>
            <Grid item size={{ sm: 12, md: 3, lg: 2.5 }}>
              <div className='profile-content'>
                <List>
                  {/* <Link to="/profile/overview">
                    <ListItem className={(splitLocation[1] === "profile" && splitLocation[2] === "overview") || (splitLocation[1] === "profile" && splitLocation[2] === "myinteraction") || (splitLocation[1] === "profile" && splitLocation[2] === "mycart") || (splitLocation[1] === "profile" && splitLocation[2] === "ordersummary") ? "active" : ""}>
                      <img src={overview} alt='overview' />
                      <span>
                        Overview
                      </span>
                    </ListItem>
                  </Link> */}
                  <Link to="/profile/account">
                    <ListItem className={splitLocation[1] === "profile" && splitLocation[2] === "account" ? "active" : ""}>
                      <img src={user} alt='user' />
                      <span>
                        My Profile
                      </span>
                    </ListItem>
                  </Link>
                  <Link to="/profile/address">
                    <ListItem className={splitLocation[1] === "profile" && (splitLocation[2] === "address" || splitLocation[2] === "addadress") ? "active" : ""}>
                      <img src={address} alt='address' />
                      <span>
                        Address
                      </span>
                    </ListItem>
                  </Link>
                  <Link to="/profile/myorders">
                    <ListItem className={(splitLocation[1] === "profile" && splitLocation[2] === "myorders") || (splitLocation[1] === "profile" && splitLocation[2] === "orders-details") ? "active" : ""}>
                      <img src={orders_icon} alt='orders_icon' />
                      <span>
                        My Orders
                      </span>
                    </ListItem>
                  </Link>
                  <Link to="/profile/myinteraction">
                    <ListItem className={splitLocation[1] === "profile" && splitLocation[2] === "myinteraction" ? "active" : ""}>
                      <img src={consultation_icon} alt='orders_icon' />
                      <span>
                        My Consultations
                      </span>
                    </ListItem>
                  </Link>
                  {/* <Link to="/profile/about">
                    <ListItem className={splitLocation[1] === "profile" && splitLocation[2] === "about" ? "active" : ""}>
                      <img src={about} alt='about' />
                      <span>
                        About us
                      </span>
                    </ListItem>
                  </Link> */}
                  {/* <Link to="/profile/faq">
                    <ListItem className={splitLocation[1] === "profile" && splitLocation[2] === "faq" ? "active" : ""}>
                      <img src={faq} alt='faq' />
                      <span>
                        FAQ’S
                      </span>
                    </ListItem>
                  </Link> */}
                  {/* <Link to="/profile/terms">
                    <ListItem className={splitLocation[1] === "profile" && splitLocation[2] === "terms" ? "active" : ""}>
                      <img src={terms_conditions} alt='terms_conditions' />
                      <span>
                        Terms & Conditions
                      </span>
                    </ListItem>
                  </Link> */}
                  {/* <Link to="/profile/privacy">
                    <ListItem className={splitLocation[1] === "profile" && splitLocation[2] === "privacy" ? "active" : ""}>
                      <img src={privacy} alt='privacy' />
                      <span>
                        Privacy Policy
                      </span>
                    </ListItem>
                  </Link> */}
                </List>
              </div>
            </Grid>
            <Grid item size={{ xs: 12, sm: 12, md: 9, lg: 9.5 }}>
              <Outlet />
            </Grid>
          </Grid>
        </Container>
      </section>
      <WhatsApp />
    </React.Fragment>
  )
}

export default Profile